import * as React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

// pass startDate and endDate as props to the component
interface AnalyticsDateRangeSelectorProps {
	startDate: Dayjs | null;
	endDate: Dayjs | null;
	setStartDate: (date: Dayjs | null) => void;
	setEndDate: (date: Dayjs | null) => void;
}

export default function AnalyticsDateRangeSelector({
	startDate,
	endDate,
	setStartDate,
	setEndDate,
}: AnalyticsDateRangeSelectorProps) {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Stack spacing={3}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						flexDirection: { xs: 'column', sm: 'row' },
					}}
					p={2}
				>
					<DatePicker
						label="Start Date"
						value={startDate}
						onChange={(newValue) => setStartDate(newValue)}
						inputFormat="DD/MM/YYYY"
						renderInput={(params) => <TextField {...params} />}
					/>
					<Box sx={{ mx: 2, display: 'inline' }}> to </Box>
					<DatePicker
						label="End Date"
						value={endDate}
						onChange={(newValue) => setEndDate(newValue)}
						inputFormat="DD/MM/YYYY"
						renderInput={(params) => <TextField {...params} />}
					/>
				</Box>
			</Stack>
		</LocalizationProvider>
	);
}
